import { Box, Typography, Button, Paper } from '@mui/material';
import { WifiOff, Refresh } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { appColors } from "../../constants/theme";

const ConnectionError = ({ onRetry, message }) => {
  const { t } = useTranslation();

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: appColors.bgMuted,
        padding: 3
      }}
    >
      <Paper
        elevation={0}
        sx={{
          padding: 4,
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center',
          borderRadius: 3
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              background: appColors.errorBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: appColors.errorDark
            }}
          >
            <WifiOff sx={{ fontSize: 48 }} />
          </Box>

          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: appColors.gray900,
                marginBottom: 1
              }}
            >
              {t('connection_error')}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: appColors.gray500,
                fontSize: '1rem',
                lineHeight: 1.6
              }}
            >
              {message || t('api_connection_failed')}
            </Typography>
          </Box>

          <Button
            variant="contained"
            startIcon={<Refresh />}
            onClick={handleRetry}
            sx={{
              padding: '12px 32px',
              fontSize: '1rem',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: 2,
              background: `linear-gradient(135deg, ${appColors.primary} 0%, ${appColors.primaryDark} 100%)`,
              '&:hover': {
                background: `linear-gradient(135deg, ${appColors.primaryDark} 0%, ${appColors.primary} 100%)`,
              }
            }}
          >
            {t('retry')}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ConnectionError;

